import React from 'react';
import { Link } from 'react-router-dom';
import { PageTemplate, Card } from '../components/ui';
import EquipmentLoanPolicyContent from '../components/EquipmentLoanPolicyContent';

export default function EquipmentLoanPolicy() {
  return (
    <PageTemplate
      title="Equipment Loan Policy"
      description="Terms of Agreement — ATL & Faculty of Arts"
    >
      <div className="max-w-3xl mx-auto space-y-6">
        <p className="font-literary text-sm text-primary-600 dark:text-gray-400">
          <Link to="/booking/equipment" className="text-primary-700 dark:text-primary-400 underline">
            ← Back to equipment booking
          </Link>
        </p>
        <Card>
          <Card.Content className="prose prose-sm dark:prose-invert max-w-none">
            <EquipmentLoanPolicyContent className="text-base" />
          </Card.Content>
        </Card>
      </div>
    </PageTemplate>
  );
}
